import useServerStateContext from '@/shared/hooks/useServerStateContext';
import { AutoIsoObjectType } from '@/features/autoIso/types';
import { useFramingTarget } from '../store/framingTargetStore';

/**
 * The target store plus whether target mode is on (`active`: a Fixed Camera
 * Clip opened it) and whether the rink and the video aim the camera right now
 * (`aiming`: also in Manual; in Auto-ISO the rink picks who to follow, as
 * always).
 */
export const useTargetAiming = () => {
  const state = useFramingTarget();
  const { selectedObjectType } = useServerStateContext();
  const active = state.session !== null;
  return { ...state, active, aiming: active && selectedObjectType === AutoIsoObjectType.None };
};
